import { listTileReducerFactory } from '../../../pillar/dashboard/store/reducers/list-tile.reducerFactory';
import { TileState } from '../../../pillar/dashboard/store/state/TileState';
import * as workspaceActions from '../../../pillar/workspace/store/actions';
import { ModuleConfiguration } from '../../submission.module.config';
import { SubmittingEntityListModel } from '../../models/SubmittingEntityListModel';
import { SubmittingEntityModel } from '../../models/SubmittingEntityModel';
import { CONFIGURE_REPORTING_SUCCESS } from '../actions/ConfigureReportingSuccessAction';

var tileStateReducer = listTileReducerFactory(ModuleConfiguration.moduleName, SubmittingEntityListModel, SubmittingEntityModel, new TileState<SubmittingEntityListModel, SubmittingEntityModel>());

export function submittingEntityReducer(state = new TileState<SubmittingEntityListModel, SubmittingEntityModel>(), action: workspaceActions.Actions<SubmittingEntityModel, any>): TileState<SubmittingEntityListModel, SubmittingEntityModel> {
  switch (action.type) {
    case CONFIGURE_REPORTING_SUCCESS:
      return {
        ...state,
        selected: {
          ...state.selected,
          isReportingConfigured: true
        }
      }
    default:
      return tileStateReducer(state, action);
  }
}



// WEBPACK FOOTER //
// ./src/app/submission/store/reducers/SubmittingEntity.reducer.ts